<template>
  <PageTable />
</template>
<script>
import PageTable from './components/table'
export default {
  name: 'master-cardMaintenance',
  components: { PageTable },
}
</script>
